import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'enumToArray',
    standalone: false
})
export class EnumToArrayPipe implements PipeTransform {
    transform(data: Object) {
        return Object.keys(data).filter(x => !isNaN(parseInt(x))).map(x => parseInt(x));
    }
}